var _style, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCallWhite = function SvgCallWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "call-white_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".call-white_svg__st0{fill:none;stroke:#fff;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10h34M15 48h34M19 2h26c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H19c-2.2 0-4-1.8-4-4V6c0-2.2 1.8-4 4-4z",
    className: "call-white_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 55,
    r: 2,
    className: "call-white_svg__st0"
  })));
};
export default SvgCallWhite;